import { render, staticRenderFns } from "./LocationConfig.vue?vue&type=template&id=167cdba7&scoped=true"
import script from "./LocationConfig.vue?vue&type=script&lang=js"
export * from "./LocationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167cdba7",
  null
  
)

export default component.exports